import { formatNumber } from "@/app/utils/helpers"
import clsx from "clsx"

const ProductDetailText = ({ label = "", text, isJustifyLeft = false, custCls }) => {
  return (
    <p className={clsx("font-agcasmlt text-charcoal-black text-sm sm:text-base lg:text-lg leading-4 sm:leading-5 lg:leading-6 block", { "text-end": isJustifyLeft }, custCls)}>
      {label && `${label}: `} {text}
    </p>
  )
}

const ProductDetailTexts = ({ ph }) => {
  const placeholders = ["Weight", "Diameter", "Thickness"]

  return (
    <>
      <ProductDetailText label={placeholders[0]} text={`${formatNumber(ph.weight)}g`} />
      <ProductDetailText label={placeholders[1]} text={`${formatNumber(ph.diameter)}cm`} />
      <ProductDetailText label={placeholders[2]} text={`${formatNumber(ph.thickness)}cm`} />
    </>
  )
}

export {
  ProductDetailText,
  ProductDetailTexts
}